export const TEST_IDS = {
    CSV_DROPDOWN: "csv-dropdown",
    TABLE_CREATION_DROPDOWN: "table-creation-dropdown",
    TABLE_SELECT: "table-select",
};
